import React from 'react'

export const HullabalookComponent = (props: {
  siteCode: string
  experienceLabel: string
}) => {
  return (
    <React.Fragment>
      <div className="hulla-container"></div>
      <script
        src={`https://${props.siteCode}.hulla-cdn.com/${props.experienceLabel}/snippet_2.0.0/snippet.js`}
      ></script>
      <script
        src={`https://${props.siteCode}.hulla-cdn.com/${props.experienceLabel}/hulla_integrate.js?loadJs=false`}
      ></script>
      <script
        src={`https://${props.siteCode}.hulla-cdn.com/${props.experienceLabel}/custom/external.js?targetClassList=hulla-container&retailerName=${props.siteCode}&experienceLabel=${props.experienceLabel}`}
      ></script>
    </React.Fragment>
  )
}

export default HullabalookComponent
